export default __webpack_public_path__ + "static/media/big_unicorn.0fb607af.png";